import EsusView from 'components/esus/EsusView'

export default function ConfiguracaoImpressaoView() {
  return <EsusView url='/pec/user/relatorios/administracao/configuracaoimpressao' />
}
